import { useEffect, useState } from "react";
import { Alert, Button, Modal, Spinner, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import adminUserCreditApi from "../../../../../api/adminUserCreditApi";
import creditRequestApi from "../../../../../api/creditRequestApi";
import Pagination from "../../../../../components/Pagination";
import UserFrymes from "../../../utils/UserFrymes";
import CreditRequestUser from "./CreditRequestUser";
import TransferFrymesModal from "./TransferFrymesModal";

const CreditsUsageReport = () => {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const userEmail = user?.userEmail;

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [userCredits, setUserCredits] = useState([]);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const [showCreditRequestModal, setShowCreditRequestModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    fetchUserCredits();
  }, []);
  const fetchUserCredits = async () => {
    try {
      const response = await creditRequestApi.getUserCredits(userEmail);
      setUserCredits(response.data);
    } catch (error) {
      console.error("Error fetching user credits", error);
    }
  };

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const res = await adminUserCreditApi.getCreditLedgerByUserEmail(
          userEmail,
          page,
          pageSize,
          sortedColumn,
          sortOrder,
        );
        setTransactions(
          Array.isArray(res.data.content) ? res.data.content : [],
        );
        setTotalPages(res.data.totalPages || 0);
        setLoading(false);
      } catch (err) {
        setError("Failed to load credit transactions.");
        console.error(err);
        setTransactions([]);
        setTotalPages(0);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    if (userEmail) {
      fetchTransactions();
    }
  }, [userEmail, page, pageSize, sortedColumn, sortOrder, refreshKey]);

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
    setPage(selectedPage);
    localStorage.setItem("all consents", selectedPage);
  };

  const handleSort = (column) => {
    if (sortedColumn === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortedColumn(column);
      setSortOrder("asc");
    }
  };
  //   const handleNavigate = () => {
  //   navigate("/dashboard/creditPassBook?tab=user");
  // }
  const handleRequestForCredits = () => {
    setShowCreditRequestModal(true);
  };
  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>
          <strong>Credit Usage Report</strong>
        </h2>
        {/* <Button onClick={handleNavigate}>Back</Button> */}
        <div className="d-flex gap-2">
          <Button variant="info" onClick={() => setShowTransferModal(true)}>
            {" "}
            Transfer Frymes{" "}
          </Button>

          <Button onClick={handleRequestForCredits}>Request For Credits</Button>
        </div>
      </div>

      <UserFrymes userCredits={userCredits} />

      {loading && <Spinner animation="border" />}
      {error && <Alert variant="danger">{error}</Alert>}

      {!loading && transactions.length === 0 && (
        <p style={{ color: "red" }}>No credit transactions found.</p>
      )}

      {!loading && transactions.length > 0 && (
        <div style={{ overflowX: "auto", width: "100%" }}>
          <Table
            striped
            bordered
            hover
            responsive
            className="mt-4"
            style={{ minWidth: "1100px", whiteSpace: "nowrap" }}
          >
            <thead>
              <tr>
                <th>Date</th>
                <th>Document Name</th>
                <th>CollabId</th>
                {/* <th>Free Frymes</th> */}
                <th>Used Credits</th>
                <th>Balance Credits</th>
                <th>Credits Bought</th>
                <th>Transaction Type</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((txn) => (
                <tr key={txn.id}>
                  <td>{txn.date}</td>
                  <td>{txn.documentName}</td>
                  <td>{txn.collabUniqueId}</td>
                  {/* <td>{txn.freeFrymes}</td> */}
                  <td>{txn.usedCredits}</td>
                  <td>{txn.balanceCredits}</td>
                  <td>{txn.creditsBought}</td>
                  <td>{txn.source}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
      {transactions.length > 0 && totalPages > 0 && (
        <div style={{ marginTop: "auto" }}>
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        </div>
      )}

      <Modal
        show={showCreditRequestModal}
        onHide={() => setShowCreditRequestModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>📨 Request Credits</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <CreditRequestUser
            onSuccess={() => setShowCreditRequestModal(false)}
          />
        </Modal.Body>
      </Modal>
      <TransferFrymesModal
        show={showTransferModal}
        onClose={() => setShowTransferModal(false)}
        onSuccess={() => setRefreshKey((prev) => prev + 1)}
      />
    </div>
  );
};

export default CreditsUsageReport;
